export function getTableHeaderSingle(state) {
  return state.tableHeaderSingle;
}

export function getTableHeaderSingleOdnostoron(state) {
  return state.tableHeaderSingleOdnostoron;
}
